import { Document } from "./../../../@types/document";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../utils/api";
import { RootState } from "./../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

export const markDocumentAsRead = createAsyncThunk(
  "documentSignerShow/markDocumentAsRead",
  async (idDocument: string, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const user = state.userAuthentication.user;
      const stakeholderReadStatus = state.utils.status.find(
        ({ code, module }) => code === "read" && module === "documentStakeholder"
      );

      const { data: documentStakeholder } = await axiosInstance.get(`${api.baseURL}documentstakeholder`, {
        params: {
          where: {
            document: idDocument,
            stakeholder: user?.id,
          },
        },
      });

      if (documentStakeholder[0].status.code === "pending") {
        // Set status firmante "leido"
        const { data } = await axiosInstance.patch(
          `${api.baseURL}documentstakeholder/${documentStakeholder[0].id}`,
          {
            status: stakeholderReadStatus?.id,
          }
        );

        return data as Document;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
